import * as React from 'react';
import { UseQueryOptions } from 'react-query';

import { usePortalConnections } from 'bones/utils/portal/usePortalConnections';
import { usePortalDemoConnection } from 'bones/utils/portal/usePortalDemoConnection';

/**
 * Returns a list of portal connections, including the "demo" connection
 */
export const usePortalConnectionsWithDemo = (
  options?: UseQueryOptions<any>
) => {
  const demoConnection = usePortalDemoConnection(options).data;
  const portalConnections = usePortalConnections(options).data;

  return React.useMemo(() => {
    if (portalConnections && demoConnection) {
      return [...portalConnections, demoConnection];
    }
    if (portalConnections) {
      return portalConnections;
    }
    if (demoConnection) {
      return [demoConnection];
    }
    return null;
  }, [portalConnections, demoConnection]);
};
